/**
 * バリデーション関連のユーティリティ関数
 */

/**
 * 電話番号からハイフンを除去
 */
export const removeHyphensFromPhone = (phone: string): string => {
  return phone.replace(/-/g, '')
}

/**
 * 電話番号にハイフンを追加（表示用）
 * 例: 09012345678 -> 090-1234-5678
 */
export const formatPhoneNumber = (phone: string): string => {
  const cleaned = removeHyphensFromPhone(phone)

  if (cleaned.length === 10) {
    // 固定電話形式: 0X-XXXX-XXXX
    return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 6)}-${cleaned.slice(6)}`
  } else if (cleaned.length === 11) {
    // 携帯電話形式: 0X0-XXXX-XXXX
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`
  }

  return phone
}

/**
 * 半角カタカナを全角カタカナに変換
 */
export const toFullWidthKana = (str: string): string => {
  const halfToFull: Record<string, string> = {
    'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
    'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
    'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
    'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
    'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
    'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
    'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
    'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
    'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
    'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
    'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
    'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
    'ｯ': 'ッ', 'ｰ': 'ー',
    'ﾞ': '゛', 'ﾟ': '゜',
  }

  return str.split('').map(char => halfToFull[char] || char).join('')
}

/**
 * ひらがなを全角カタカナに変換
 */
export const hiraganaToKatakana = (str: string): string => {
  return str.replace(/[\u3041-\u3096]/g, (match) => {
    const chr = match.charCodeAt(0) + 0x60
    return String.fromCharCode(chr)
  })
}

/**
 * 名前のフルネームを生成
 */
export const getFullName = (lastName: string, firstName: string): string => {
  return `${lastName} ${firstName}`
}

/**
 * UUIDv4を生成
 */
export const generateUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
